module.exports = __webpack_public_path__ + "static/media/noProfileImage.70e43cdd.png";